"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@angular/material");
const BaseComponent_1 = require("../BaseComponent");
const forms_1 = require("@angular/forms");
const rxjs_1 = require("rxjs");
const router_1 = require("@angular/router");
class EmbedCodeDialog extends BaseComponent_1.BaseComponent {
    constructor(router, snackBar, dialogRef, data, dialog) {
        super(router, snackBar, dialog);
        this.router = router;
        this.snackBar = snackBar;
        this.dialogRef = dialogRef;
        this.data = data;
        this.dialog = dialog;
        this.embedCodeControl = new forms_1.FormControl('');
        this.widthControl = new forms_1.FormControl('');
        this.widthUnitControl = new forms_1.FormControl('');
        this.heightControl = new forms_1.FormControl('');
        this.heightUnitControl = new forms_1.FormControl('');
        this.init();
        // Set defaults
        this.url = data.url;
        this.widthControl.setValue(typeof data.width !== 'undefined' ? data.width : 100);
        this.widthUnitControl.setValue(typeof data.widthUnit !== 'undefined' ? data.widthUnit : '%');
        this.heightControl.setValue(typeof data.height !== 'undefined' ? data.height : 100);
        this.heightUnitControl.setValue(typeof data.heightUnit !== 'undefined' ? data.heightUnit : '%');
    }
    init() {
        let widthEmbedControlWater = new EmbedControlWatcher(this.widthControl);
        widthEmbedControlWater.valueChanged().subscribe(newVal => {
            this.width = newVal;
            this.generateEmbedCode();
        });
        let widthUnitEmbedControlWater = new EmbedControlWatcher(this.widthUnitControl);
        widthUnitEmbedControlWater.valueChanged().subscribe(newVal => {
            this.widthUnit = newVal;
            this.generateEmbedCode();
        });
        let heightEmbedControlWater = new EmbedControlWatcher(this.heightControl);
        heightEmbedControlWater.valueChanged().subscribe(newVal => {
            this.height = newVal;
            this.generateEmbedCode();
        });
        let heightUnitEmbedControlWater = new EmbedControlWatcher(this.heightUnitControl);
        heightUnitEmbedControlWater.valueChanged().subscribe(newVal => {
            this.heightUnit = newVal;
            this.generateEmbedCode();
        });
    }
    copyToClipboard() {
        let embedCode = this.embedCodeControl.value;
        const listener = function (ev) {
            ev.preventDefault();
            ev.clipboardData.setData('text/plain', embedCode);
        };
        document.addEventListener('copy', listener);
        document.execCommand('copy');
        document.removeEventListener('copy', listener);
        // assume success
        this.openSnackBarSuccess('GENERIC.COPIED');
    }
    done() {
        this.dialogRef.close();
    }
    generateEmbedCode() {
        this.embedCodeControl.setValue(`<iframe src="${this.url}" height="${this.height}${this.heightUnit}" width="${this.width}${this.widthUnit}" style="border: none;"></iframe>`);
    }
}
exports.EmbedCodeDialog = EmbedCodeDialog;
class EmbedControlWatcher {
    constructor(formControl) {
        this.formControl = formControl;
    }
    valueChanged() {
        const observable = new rxjs_1.Observable(subscriber => {
            this.formControl.valueChanges.subscribe(x => {
                if (this.formControl.valid) {
                    subscriber.next(x);
                }
            });
        });
        return observable;
    }
}
